import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheAbilenePropertyExperts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-abilene-property-experts" className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/modern_farmhouse_neighborhood_hero.png)] bg-cover bg-center bg-no-repeat" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-black/40 bg-gradient-to-b from-black/20 via-black/40 to-black/60" />

      {}
      <div ref={ref} className={cn("relative z-20 container mx-auto px-4 text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h1 className="mx-auto mb-8 max-w-4xl font-serif text-4xl font-bold leading-tight text-white drop-shadow-md md:text-6xl lg:text-7xl">
          Management Excellence for Owners. <br className="hidden md:block" />
          Lifestyle Flexibility for Renters.
        </h1>

        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
          <Button asChild size="lg" className="h-14 min-w-[200px] rounded-none bg-secondary text-lg font-semibold text-secondary-foreground shadow-lg hover:bg-secondary/90 hover:scale-105 transition-transform duration-300">
            <Link to="/OwnerServicesPage">List Your Property</Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 min-w-[200px] rounded-none border-2 border-white bg-transparent text-lg font-semibold text-white shadow-lg hover:bg-white hover:text-primary hover:scale-105 transition-transform duration-300">
            <Link to="/FindHomePage">Find a Home</Link>
          </Button>
        </div>
      </div>
    </section>;
}